module.exports = __webpack_public_path__ + "static/media/homepage-section-1.e4ead82d.png";